<template>
  <div v-elm-resize="onResize" class="card-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {
    onResize(entities) {
      let width = this.$el.getBoundingClientRect().width;
      let padding = '2rem';
      if (width > 600) {
        padding = '15%';
      } else if (width > 960) {
        padding = '30%';
      } else if (width > 1264) {
        padding = '40%';
      }
      this.$el.style.paddingLeft = padding;
      this.$el.style.paddingRight = padding;
    }
  }
};
</script>

<style lang="stylus" scoped>
.card-container {
  padding: 2rem;
  background-color: $def-bg-color;
}
</style>
